import Link from "next/link";
const SitemapComponent = () => {
  return (
    <div className="wrapper">
      <div className="container">
        <div>
          <Link href="/" as="/">
            <a>
              <p className="title">Homepage</p>
            </a>
          </Link>
          <div>
            <p className="title margin-8 none-cursor">Layanan</p>
            <div className="flex">
              <div className="font-16">
                <Link href="/kredit-online" as="/kredit-online">
                  <a>
                    <p>Belanja Online</p>
                  </a>
                </Link>
                <Link href="/belanja-di-toko" as="/belanja-di-toko">
                  <a>
                    <p>Belanja di Toko</p>
                  </a>
                </Link>
                <div className="subcategory-wrapper font-16">
                  <Link href="/kredit-hp" as="/kredit-hp">
                    <a>
                      <p>Pembiayaan Handphone</p>
                    </a>
                  </Link>
                  <Link href="/kredit-kamera" as="/kredit-kamera">
                    <a>
                      <p>Pembiayaan Kamera</p>
                    </a>
                  </Link>
                  <Link href="/kredit-tv" as="/kredit-tv">
                    <a>
                      <p>Pembiayaan TV</p>
                    </a>
                  </Link>
                  <Link href="/kredit-laptop" as="/kredit-laptop">
                    <a>
                      <p>Pembiayaan Laptop</p>
                    </a>
                  </Link>
                  <Link href="/kredit-furnitur" as="/kredit-furnitur">
                    <a>
                      <p>Pembiayaan Furnitur</p>
                    </a>
                  </Link>
                  <Link href="/kredit-gadget" as="/kredit-gadget">
                    <a>
                      <p>Pembiayaan Gadget</p>
                    </a>
                  </Link>
                </div>
              </div>
              <div className="margin-20">
                <Link href="/kartukredit" as="/kartukredit">
                  <a>
                    <p className="font-16">Kartu Kredit</p>
                  </a>
                </Link>
                {/* HIDE MPF
                <Link href="/kredit-multiguna" as="/kredit-multiguna">
                  <a>
                    <p className="font-16">Pembiayaan Multiguna</p>
                  </a>
                </Link>
                <Link
                  href="/kredit-multiguna/pinjaman-tunai-pelanggan-lama-tanpa-jaminan"
                  as="/kredit-multiguna/pinjaman-tunai-pelanggan-lama-tanpa-jaminan"
                >
                  <a className="subcategory-wrapper font-16">FlexiFast</a>
                </Link> */}
              </div>
              <div className="margin-110">
                <Link href="/proteksi" as="/proteksi">
                  <a>
                    <p className="font-16">Proteksi</p>
                  </a>
                </Link>
                <div className="subcategory-wrapper font-16">
                  <Link
                    href="/asuransi-cicilan-kredit"
                    as="/asuransi-cicilan-kredit"
                  >
                    <a>
                      <p>AMAN</p>
                    </a>
                  </Link>
                  <Link
                    href="/asuransi-barang-elektronik"
                    as="/asuransi-barang-elektronik"
                  >
                    <a>
                      <p>proSERIES</p>
                    </a>
                  </Link>
                  <Link href="/asuransi-isi-rumah" as="/asuransi-isi-rumah">
                    <a>
                      <p>SANTAI</p>
                    </a>
                  </Link>
                  <Link href="/asuransi-gadget" as="/asuransi-gadget">
                    <a>
                      <p>EasyCover & MaxCover</p>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* bagian 2 */}
        <div className="flex">
          <div className="title margin-64 none-cursor">
            Promo & Penawaran
            <div className="font-16">
              <Link href="/promo-dan-penawaran" as="/promo-dan-penawaran">
                <a>
                  <p>Promo</p>
                </a>
              </Link>
              <Link href="/rewards" as="/rewards">
                <a>
                  <p>Home Credit Rewards</p>
                </a>
              </Link>
            </div>
          </div>
          <Link href="/go-ers" as="/go-ers">
            <a>
              <p className="title margin-64 margin-20">Home Credit Go</p>
            </a>
          </Link>
          <Link href="/mitra" as="/mitra">
            <a>
              <p className="title margin-64 margin-250">Mitra</p>
            </a>
          </Link>
        </div>
        {/* bagian3 */}
        <div className="flex">
          <Link href="/temukan-lokasi-kami" as="/temukan-lokasi-kami">
            <a className="title margin-64">Temukan Lokasi Kami</a>
          </Link>
          <div className="title margin-64">
            <Link href="/panduan-konsumen" as="/panduan-konsumen">
              <a>Panduan Konsumen</a>
            </Link>
            <div className="font-16">
              <Link
                href="/panduan-konsumen/my-home-credit-app"
                as="/panduan-konsumen/my-home-credit-app"
              >
                <a>
                  <p>My Home Credit App</p>
                </a>
              </Link>
              <Link
                href="/panduan-konsumen/tanda-tangan-elektronik"
                as="/panduan-konsumen/tanda-tangan-elektronik"
              >
                <a>
                  <p>Tanda Tangan Elektronik</p>
                </a>
              </Link>
              <Link
                href="/panduan-konsumen/biaya-denda-dan-bunga"
                as="/panduan-konsumen/biaya-denda-dan-bunga"
              >
                <a>
                  <p>Biaya, Denda, dan Bunga</p>
                </a>
              </Link>
              <Link
                href="/panduan-konsumen/keluhan"
                as="/panduan-konsumen/keluhan"
              >
                <a>
                  <p>Keluhan</p>
                </a>
              </Link>
            </div>
          </div>
          <div className="title margin-64">
            <Link href="/cara-pembayaran" as="/cara-pembayaran">
              <a>Cara Pembayaran</a>
            </Link>
            <div className="font-16">
              <Link
                href="/cara-pembayaran/my-home-credit-app"
                as="/cara-pembayaran/my-home-credit-app"
              >
                <a>
                  <p>Pembayaran Melalui My Home Credit App</p>
                </a>
              </Link>
              <Link
                href="/cara-pembayaran/transfer-bank"
                as="/cara-pembayaran/transfer-bank"
              >
                <a>
                  <p>Pembayaran Melalui Transfer Bank</p>
                </a>
              </Link>
              <Link
                href="/cara-pembayaran/gerai-retail"
                as="/cara-pembayaran/gerai-retail"
              >
                <a>
                  <p>Pembayaran Melalui Gerai Retail</p>
                </a>
              </Link>
              <Link
                href="/cara-pembayaran/e-commerce"
                as="/cara-pembayaran/e-commerce"
              >
                <a>
                  <p>Pembayaran Melalui E-Commerce</p>
                </a>
              </Link>
              <Link
                href="/cara-pembayaran/electronic-money"
                as="/cara-pembayaran/electronic-money"
              >
                <a>
                  <p>Pembayaran Melalui Electronic Money</p>
                </a>
              </Link>
              <Link
                href="/cara-pembayaran/isi-saldo-home-credit-pay"
                as="/cara-pembayaran/isi-saldo-home-credit-pay"
              >
                <a>
                  <p>Isi Saldo Home Credit Pay</p>
                </a>
              </Link>
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="title margin-64">
            <Link href="/tentang-perusahaan" as="/tentang-perusahaan">
              <a>Tentang Perusahaan</a>
            </Link>
            <div className="font-16">
              <Link
                href="/tentang-perusahaan/siaran-pers"
                as="/tentang-perusahaan/siaran-pers"
              >
                <a>
                  <p>Siaran Pers</p>
                </a>
              </Link>
              <Link
                href="/tentang-perusahaan/acara-perusahaan"
                as="/tentang-perusahaan/acara-perusahaan"
              >
                <a>
                  <p>Acara Perusahaan</p>
                </a>
              </Link>
              <Link
                href="/tentang-perusahaan/penghargaan-kami"
                as="/tentang-perusahaan/penghargaan-kami"
              >
                <a>
                  <p>Penghargaan Kami</p>
                </a>
              </Link>
            </div>
          </div>
          <Link href="/pertanyaan-umum" as="/pertanyaan-umum">
            <a className="title margin-64">Pertanyaan Umum</a>
          </Link>
          <Link href="/hubungi-kami" as="/hubungi-kami">
            <a className="title margin-64 margin-170">Hubungi Kami</a>
          </Link>
        </div>
        <div className="special-section">
          <Link href="/blog" as="/blog">
            <a className="title margin-64 width-36">Blog</a>
          </Link>
          <Link href="/syarat-dan-ketentuan" as="/syarat-dan-ketentuan">
            <a className="title margin-64 width-34">Syarat & Ketentuan</a>
          </Link>
          <Link href="/kebijakan-privasi" as="/kebijakan-privasi">
            <a className="title margin-64">Kebijakan Privasi</a>
          </Link>
        </div>
        <div className="flex">
          <Link href="/sitemap" as="/sitemap">
            <a className="title margin-64 margin-bot-64">Sitemap</a>
          </Link>
        </div>
      </div>
      <style jsx>{`
        .subcategory-wrapper {
          margin-left: 20px;
        }
        .container {
          width: 940px;
        }
        .wrapper {
          display: flex;
          justify-content: center;
          -webkit-tap-highlight-color: transparent;
        }
        .flex {
          display: flex;
          justify-content: space-between;
        }
        .title {
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
        }
        .font-16 {
          font-size: 16px;
          font-weight: normal;
          cursor: pointer;
        }
        .margin-8 {
          margin: 0 0 8px 0;
        }
        .margin-64 {
          margin: 64px 0 8px 0;
        }
        .margin-250 {
          margin-right: 250px;
        }
        .margin-20 {
          margin-right: 20px;
        }
        .margin-110 {
          margin-right: 110px;
        }
        .margin-170 {
          margin-right: 170px;
        }
        .special-section {
          display: flex;
        }
        .width-36 {
          width: 36%;
        }
        .width-34 {
          width: 34%;
        }
        .margin-bot-64 {
          margin-bottom: 64px;
        }
        .none-cursor {
          cursor: auto;
        }
        @media only screen and (max-width: 730px) {
          .margin-250,
          .margin-20,
          .margin-110,
          .margin-170,
          margin-20 {
            margin: 0px;
          }
          .flex,
          .special-section {
            flex-direction: column;
          }
          .wrapper {
            padding: 0 16px;
          }
          .margin-64 {
            margin: 16px 0 8px 0;
          }
          .width-34 {
            width: auto;
          }
          .width-36 {
            width: auto;
          }
          .margin-bot-64 {
            margin: 16px 0 64px 0;
          }
          .title {
            font-size: 16px;
          }
          .font-16 {
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};
export default SitemapComponent;
